import script from "./NavHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./NavHeader.vue?vue&type=script&setup=true&lang=js"

import "./NavHeader.vue?vue&type=style&index=0&id=896bf0d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-896bf0d4"]])

export default __exports__